import React, { Component } from 'react';

import compose from 'recompose/compose';
import ReactDOM from "react-dom";
// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import BarLoader from "react-spinners/BarLoader";
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import html2canvas from "html2canvas";
//Components
import Availability from '../../components/Availability';
import ResponseTime from '../../components/ResponseTime';
import Statistics from '../../components/Statistics';
import Percentage from '../Percentage'
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es' 
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { chart } from 'highcharts';
import { Chat } from '@material-ui/icons';
import {getPdfPeriodical} from '../../../../services/getPdfPeriodical'
moment.locale('es')

class PdfPeriodical extends Component {
    constructor(props) {
        super(props);
        //console.log('params', props.params.params.location.state.fromObjective)
        this.tableDowntime=React.createRef();
        this.summaryTable=React.createRef();
        this.state = {
            params:props.params,
            schedule:props.schedule,
            actualYear:props.year,
            // actualYear:moment().year(),
            selectMonth:props.month,
            indexMonth:props.indexMonth,
            ObjectiveData:this.props.params.params.location.state.fromObjective,
            // modalLoad:false,
            modalLoad:true,
            modalPdf:false,
            modalnoData:false,
            monthSelected:props.indexMonth +1,
            yearSelected:props.year,
            token:sessionStorage.getItem("key")
        }
    }
    
    handlePeriodical=()=>{
        const {ObjectiveData}=this.state
        ObjectiveData.Pasos.map(l=>{
            // GRAFICOS CON PASOS
            sessionStorage.removeItem('chartDistributionAvailability'+l.id_paso);
            sessionStorage.removeItem('chartDistributionConsolidated'+l.id_paso);
            sessionStorage.removeItem('chartDistributionIsp'+l.id_paso);
            sessionStorage.removeItem('chartResponseTimeForStep'+l.id_paso);
            sessionStorage.removeItem('chartResponseTimeForNode'+l.id_paso);
        })
        // GRAFICOS
        sessionStorage.removeItem('chartAvailabilityConsolidated');
        sessionStorage.removeItem('chartAvailabilityConsolidatedPerStep');
        sessionStorage.removeItem('chartResponseTimeGeneral');
        sessionStorage.removeItem('chartAvailabilityNode');
        sessionStorage.removeItem('chartAvailabilityNodeDetail');
        sessionStorage.removeItem('chartAvailabilityStep');
        sessionStorage.removeItem('chartAbsoluteFrecuency');
        sessionStorage.removeItem('chartCumulativeFrecuency');
        sessionStorage.removeItem('chartResponseTimeGeneral');
        sessionStorage.removeItem('chartResponseTimeGeneralDay');
        // TABLAS
        sessionStorage.removeItem('tableAvailability');
        sessionStorage.removeItem('AvailabilityDowntimeContTables');
        sessionStorage.removeItem('AvailabilityTableDownCum');
        sessionStorage.removeItem('AvailabilityTableNoMonCum');
        this.props.handleMainPeriodical('hola')

    }

    //VERIFICACION SI CARGO UNO DE LAS SESSIONES MAS PESADAS, SI NO VUELVE A CARGAR EL COMPONENTE
    checkSession=async ()=>{
        // console.log(sessionStorage.getItem('chartAvailabilityConsolidated'),"chartAvailabilityConsolidated");

        let chartAvailabilityConsolidated = sessionStorage.getItem('chartAvailabilityConsolidated') 

        if (chartAvailabilityConsolidated === 'false') {
            this.noData()
        }else{
            const {ObjectiveData}=this.state
            let review = false
            await new Promise((resolve) => {
                setTimeout(()=>{
                    ObjectiveData.Pasos.map(l=>{
                        if(!JSON.parse(sessionStorage.getItem("chartResponseTimeForStep"+l.id_paso))){
                            review = true
                        }
                        
                        if(!JSON.parse(sessionStorage.getItem("chartDistributionConsolidated"+l.id_paso))){
                            review = true
                        }
                        if(!JSON.parse(sessionStorage.getItem("chartDistributionIsp"+l.id_paso))){
                            review = true
                        }
                        if (ObjectiveData.servicio_id != 666) {
                            if(!JSON.parse(sessionStorage.getItem("chartDistributionAvailability"+l.id_paso))){
                                review = true
                            }
                        }
                    })
                    
                    if(!sessionStorage.getItem("chartAvailabilityConsolidated")||!sessionStorage.getItem("chartAvailabilityConsolidatedPerStep") ||
                    !sessionStorage.getItem("chartResponseTimeGeneral")||!sessionStorage.getItem("chartAvailabilityStep") ||
                    !sessionStorage.getItem("chartAvailabilityGeneral")||!sessionStorage.getItem("chartAvailabilityNode")||
                        !sessionStorage.getItem("chartAvailabilityNodeDetail")||!sessionStorage.getItem("chartResponseTimeGeneralDay")||
                        !sessionStorage.getItem("chartAbsoluteFrecuency")||!sessionStorage.getItem("chartCumulativeFrecuency")||
                        !sessionStorage.getItem("AvailabilityDowntimeContTables") || !sessionStorage.getItem("tableAvailability")
                        )
                        { 
                            console.log("ENTRE AL IF DISTINTO")
                            review = true
                        } else {
                            // console.log(JSON.parse(sessionStorage.getItem("chartAvailabilityConsolidatedPerStep")));
                            if(JSON.parse(sessionStorage.getItem("chartAvailabilityConsolidated")).series.length===0||JSON.parse(sessionStorage.getItem("chartAvailabilityConsolidatedPerStep")).series.length===0 ||
                                JSON.parse(sessionStorage.getItem("chartResponseTimeGeneral")).series.length===0||JSON.parse(sessionStorage.getItem("chartAvailabilityStep")).series.length===0 ||
                                JSON.parse(sessionStorage.getItem("chartAvailabilityGeneral")).series.length===0||JSON.parse(sessionStorage.getItem("chartAvailabilityNode")).series.length===0||
                                JSON.parse(sessionStorage.getItem("chartAvailabilityNodeDetail")).series.length===0||JSON.parse(sessionStorage.getItem("chartResponseTimeGeneralDay")).series.length===0||
                                JSON.parse(sessionStorage.getItem("chartAbsoluteFrecuency")).series.length===0||JSON.parse(sessionStorage.getItem("chartCumulativeFrecuency")).series.length===0||
                                JSON.parse(sessionStorage.getItem("AvailabilityDowntimeContTables")) === 0 || JSON.parse(sessionStorage.getItem("tableAvailability")).length===0
                                ){
                                    console.log("ENTRE AL IF SERIE")
                                    review = true
                                }
                        }
                        resolve()

                }, 5000)
            })
            if (review) {
                console.log('SI');
                this.checkSession()
            } else {
                console.log('NO');
                this.chargeData()            
            }
        }
    }

    componentDidMount() {
        //LLAMA A METODO QUE CHECKEA CARGA DE SESSION
        
            this.checkSession()
            
        
    }
    //CAMBIA ESTADO DE MODALES
    chargeData=()=>{
        // console.log("chargedata")
        this.setState({
            modalLoad:false,
            modalnoData:false,
            modalPdf:true
            // modalPdf:false
        })
    }

    noData=()=>{
        // console.log("chargedata")
        this.setState({
            modalnoData:true,
            modalLoad:false,
            modalPdf:false
        })
    }

    fetchConsolidado=(ObjectiveData, selectMonth,actualYear)=>{
        
        const {monthSelected,yearSelected,token}=this.state
        
        if(monthSelected === 12){
            var monthSelectedEnd = 1
            var yearSelectedEnd = (yearSelected + 1) 
        }else{
            var monthSelectedEnd = (monthSelected + 1) 
            
        }
        var dataChart = []
        var dataTablesForStep = []  // Table por paso
        var dataTablesDownGlobal = []  // Table Downtime Global
        var dataTotalDownGlobal = []  // Total Table Downtime Global

        var dateBeginPdf = "01/" +monthSelected+"/"+yearSelected
        var dateEndPdf = "01/" +monthSelectedEnd+"/"+yearSelected

        if(monthSelected <= 9){
            var dateBeginPdf = "01/0" +monthSelected+"/"+yearSelected
        }

        if(monthSelectedEnd <= 9 ){
            if (monthSelected === 12) {
                var dateEndPdf = "01/0" +monthSelectedEnd+"/"+yearSelectedEnd
            }else{
                var dateEndPdf = "01/0" +monthSelectedEnd+"/"+yearSelected
            }
            
        }

        // DISPONIBILIDAD CONSOLIDADA    
        let ConsolidatedCategorie = sessionStorage.getItem('ConsolidatedCategorie') 
        ConsolidatedCategorie = JSON.parse(ConsolidatedCategorie)

        let ConsolidatedSeries = sessionStorage.getItem('ConsolidatedSeries') 
        ConsolidatedSeries = JSON.parse(ConsolidatedSeries)
            
        let chartOptionsStackedBarConsolidated = sessionStorage.getItem('chartAvailabilityConsolidated') 
        chartOptionsStackedBarConsolidated = JSON.parse(chartOptionsStackedBarConsolidated)

        
        chartOptionsStackedBarConsolidated.yAxis.labels.align = 'left'
        chartOptionsStackedBarConsolidated.yAxis.offset = 110
        chartOptionsStackedBarConsolidated.yAxis.labels.x = 10
        chartOptionsStackedBarConsolidated.yAxis.categories = ConsolidatedCategorie
        chartOptionsStackedBarConsolidated.series = ConsolidatedSeries
        chartOptionsStackedBarConsolidated.plotOptions.series.turboThreshold = 30000
        chartOptionsStackedBarConsolidated.plotOptions.series.boostThreshold = 1
        chartOptionsStackedBarConsolidated.chart.height = 150
        chartOptionsStackedBarConsolidated.title.text="1. DISPONIBILIDAD CONSOLIDADA"
        chartOptionsStackedBarConsolidated.title.align="left"
        chartOptionsStackedBarConsolidated.title.style.fontSize="14px"
        chartOptionsStackedBarConsolidated.subtitle.text="Corresponde a la disponibilidad total de todas las mediciones desde todos los nodos del objetivo durante el período y horario seleccionado."
        chartOptionsStackedBarConsolidated.subtitle.align="left"
        chartOptionsStackedBarConsolidated.subtitle.style.fontSize="11px"
        chartOptionsStackedBarConsolidated.subtitle.style.color="#909090"
        chartOptionsStackedBarConsolidated = JSON.stringify(chartOptionsStackedBarConsolidated)
        dataChart.push(chartOptionsStackedBarConsolidated)
                
        // DISPONIBILIDAD CONSOLIDADA POR NODO
        let chartAvailabilityConsolidated = sessionStorage.getItem('chartAvailabilityConsolidated') 
        chartAvailabilityConsolidated = JSON.parse(chartAvailabilityConsolidated)
        chartAvailabilityConsolidated.yAxis.labels.align = 'left'
        chartAvailabilityConsolidated.yAxis.offset = 110
        chartAvailabilityConsolidated.yAxis.labels.x = 10
        chartAvailabilityConsolidated.plotOptions.series.turboThreshold = 30000
        chartAvailabilityConsolidated.plotOptions.series.boostThreshold = 1
        chartAvailabilityConsolidated.title.text="2. DISPONIBILIDAD CONSOLIDADA POR NODO"
        chartAvailabilityConsolidated.title.align="left"
        chartAvailabilityConsolidated.title.style.fontSize="14px"
        chartAvailabilityConsolidated.subtitle.text="Corresponde a los estados del objetivo medidos desde cada ISP desde donde se realizan los monitoreos."
        chartAvailabilityConsolidated.subtitle.align="left"
        chartAvailabilityConsolidated.subtitle.style.fontSize="11px"
        chartAvailabilityConsolidated.subtitle.style.color="#909090"
        chartAvailabilityConsolidated = JSON.stringify(chartAvailabilityConsolidated)
        dataChart.push(chartAvailabilityConsolidated)


        // TABLA DISPONIBILIDAD RESUMEN
        let chartTableAvailability = sessionStorage.getItem('tableAvailability')
        dataTablesForStep.push(chartTableAvailability)
        

        // TABLA DISPONIBILIDAD DOWNTIME GLOBAL  
        for (var i = 0; i < sessionStorage.getItem("AvailabilityDowntimeContTables"); i ++) {
            let chartAvailabilityDowntimeContTables = JSON.parse(sessionStorage.getItem("AvailabilityDowntimeTables_"+i))
            dataTablesDownGlobal.push(chartAvailabilityDowntimeContTables)
        }  

        let chartAvailabilityTableDownCum = sessionStorage.getItem('AvailabilityTableDownCum')
        dataTotalDownGlobal.push(chartAvailabilityTableDownCum)

        let chartAvailabilityTableNoMonCum = sessionStorage.getItem('AvailabilityTableNoMonCum')
        dataTotalDownGlobal.push(chartAvailabilityTableNoMonCum)

        
        // var tasks=[]    
        let nameObjetivo = 'Reporte_Periodico_'+ObjectiveData.nombre+'_Mes_'+selectMonth+'_Año_'+actualYear
        let nameObjetivoHead = ObjectiveData.nombre
        let datePdf = dateBeginPdf+' - '+dateEndPdf
      
        this.setState({
            modalLoad:true,
            modalnoData:false,
            modalPdf:false
        })

        var data ={"name":nameObjetivo, // Nombre del Objetivo
                "nameHead":nameObjetivoHead, // Nombre head pdf del Objetivo
                "datePdf":datePdf, // Fecha pdf
                "charts":dataChart, // Graficos
                "tablesForStep":dataTablesForStep, // Tabla por paso
                "tablesDownGlobal":dataTablesDownGlobal, // Tabla Downtime Global
                "dataTotalDownGlobal":dataTotalDownGlobal,// Total Tabla Downtime Global
                "pdf":"periodical",
                "token":''} 
                
        var data =JSON.stringify(data)

        this.processDataConsolidado(data,nameObjetivo)
        
        
    }

    prepareData=(ObjectiveData, selectMonth,actualYear)=>{

        const {token}=this.state
                
        var dataChart = []
        // DISPONIBILIDAD CONSOLIDADA POR PASO
        let chartAvailabilityConsolidatedPerStep = sessionStorage.getItem('chartAvailabilityConsolidatedPerStep')
        chartAvailabilityConsolidatedPerStep = JSON.parse(chartAvailabilityConsolidatedPerStep)
        chartAvailabilityConsolidatedPerStep.yAxis.labels.align = 'left'
        chartAvailabilityConsolidatedPerStep.yAxis.offset = 110
        chartAvailabilityConsolidatedPerStep.yAxis.labels.x = 10
        chartAvailabilityConsolidatedPerStep.title.text="3. DISPONIBILIDAD CONSOLIDADA POR PASO"
        chartAvailabilityConsolidatedPerStep.title.align="left"
        chartAvailabilityConsolidatedPerStep.title.style.fontSize="14px"
        chartAvailabilityConsolidatedPerStep.subtitle.text="Corresponde a la disponibilidad global de cada paso del objetivo monitoreado."
        chartAvailabilityConsolidatedPerStep.subtitle.align="left"
        chartAvailabilityConsolidatedPerStep.subtitle.style.fontSize="11px"
        chartAvailabilityConsolidatedPerStep.subtitle.style.color="#909090"
        chartAvailabilityConsolidatedPerStep = JSON.stringify(chartAvailabilityConsolidatedPerStep)    
        dataChart.push(chartAvailabilityConsolidatedPerStep)


        // Disponibilidad Total Consolidada
        let chartAvailabilityGeneral = sessionStorage.getItem('chartAvailabilityGeneral')
        chartAvailabilityGeneral = JSON.parse(chartAvailabilityGeneral)
        chartAvailabilityGeneral.title.text="4. DISPONIBILIDAD TOTAL CONSOLIDADA"
        chartAvailabilityGeneral.title.align="left"
        chartAvailabilityGeneral.title.style.fontSize="14px"
        chartAvailabilityGeneral.yAxis.labels.enabled="true"
        chartAvailabilityGeneral.yAxis.gridLineWidth="1"
        chartAvailabilityGeneral = JSON.stringify(chartAvailabilityGeneral)
        dataChart.push(chartAvailabilityGeneral)

        // Disponibilidad Consolidada Por ISP *****
        let chartAvailabilityNode = sessionStorage.getItem('chartAvailabilityNode')
        chartAvailabilityNode = JSON.parse(chartAvailabilityNode)
        chartAvailabilityNode.title.text="5. DISPONIBILIDAD CONSOLIDADA POR ISP"
        chartAvailabilityNode.title.align="left"
        chartAvailabilityNode.title.style.fontSize="14px"
        chartAvailabilityNode = JSON.stringify(chartAvailabilityNode)
        dataChart.push(chartAvailabilityNode)

        // Disponibilidad Detalle Por ISP
        let chartAvailabilityNodeDetail = sessionStorage.getItem('chartAvailabilityNodeDetail')
        chartAvailabilityNodeDetail = JSON.parse(chartAvailabilityNodeDetail)
        chartAvailabilityNodeDetail.title.text="6. DISPONIBILIDAD DETALLE POR ISP"
        chartAvailabilityNodeDetail.title.align="left"
        chartAvailabilityNodeDetail.title.style.fontSize="14px"
        chartAvailabilityNodeDetail = JSON.stringify(chartAvailabilityNodeDetail)
        dataChart.push(chartAvailabilityNodeDetail)

        // Disponibilidad Distribución Porcentual
        let chartAvailabilityStep = sessionStorage.getItem('chartAvailabilityStep') 
        chartAvailabilityStep = JSON.parse(chartAvailabilityStep)
        chartAvailabilityStep.title.text="7. DISPONIBILIDAD DISTRIBUCIÓN PORCENTUAL"
        chartAvailabilityStep.title.align="left"
        chartAvailabilityStep.title.style.fontSize="14px"
        chartAvailabilityStep.yAxis.labels.enabled="true"
        chartAvailabilityStep.yAxis.gridLineWidth="1"
        chartAvailabilityStep = JSON.stringify(chartAvailabilityStep)
        dataChart.push(chartAvailabilityStep)

        // Disponibilidad Frecuencia Absoluta
        let chartAbsoluteFrecuency = sessionStorage.getItem('chartAbsoluteFrecuency') 
        chartAbsoluteFrecuency = JSON.parse(chartAbsoluteFrecuency)
        chartAbsoluteFrecuency.title.text="8. DISPONIBILIDAD FRECUENCIA ABSOLUTA"
        chartAbsoluteFrecuency.title.align="left"
        chartAbsoluteFrecuency.title.style.fontSize="14px"
        chartAbsoluteFrecuency.legend = {enabled: true}
        chartAbsoluteFrecuency.subtitle.text="Corresponde a la cantidad de mediciones para cada tiempo de respuesta del objetivo durante el período seleccionado. "
        chartAbsoluteFrecuency.subtitle.align="left"
        chartAbsoluteFrecuency.subtitle.style.fontSize="11px"
        chartAbsoluteFrecuency.subtitle.style.color="#909090" 
        chartAbsoluteFrecuency = JSON.stringify(chartAbsoluteFrecuency)
        dataChart.push(chartAbsoluteFrecuency)
        sessionStorage.removeItem('chartAbsoluteFrecuency') 

        // Disponibilidad Frecuencia Acumulada
        let chartCumulativeFrecuency = sessionStorage.getItem('chartCumulativeFrecuency')
        chartCumulativeFrecuency = JSON.parse(chartCumulativeFrecuency)
        chartCumulativeFrecuency.title.text="9. DISPONIBILIDAD FRECUENCIA ACUMULADA"
        chartCumulativeFrecuency.title.align="left"
        chartCumulativeFrecuency.title.style.fontSize="14px"
        chartCumulativeFrecuency.legend = {enabled: true}
        chartCumulativeFrecuency = JSON.stringify(chartCumulativeFrecuency)
        dataChart.push(chartCumulativeFrecuency)

        if (ObjectiveData.servicio_id != 666) {
            ObjectiveData.Pasos.map(l=>{
                // Distribucion Porcentual- Disponibilidad  ******
                let chartDistributionAvailability = sessionStorage.getItem('chartDistributionAvailability'+l.id_paso)
                chartDistributionAvailability = JSON.parse(chartDistributionAvailability)    
                chartDistributionAvailability.colors= ["#141D39", "#CF6E29", "#325088", "#20385F", "#30206C"]
                chartDistributionAvailability.title.text= "10. DISTRIBUCIÓN PORCENTUAL - DISPONIBILIDAD / PASO ("+l.nombre_paso +")"
                chartDistributionAvailability.title.align = 'left'
                chartDistributionAvailability.title.style.color = '#000'
                chartDistributionAvailability.title.style.fontFamily= 'Calibri, sans-serif'
                chartDistributionAvailability.title.style.fontSize="14px"
                chartDistributionAvailability.title.style.fontWeight= "bold"
                if (l.id_paso === "0") {
                    chartDistributionAvailability.subtitle.text="El gráfico muestra, para cada ISP desde donde se monitorea el objetivo, el porcentaje correspondiente a cada tipo de error encontrado, considerando como 100% el valor del downtime consolidado por cada paso en cada ISP. "
                    chartDistributionAvailability.subtitle.align="left"
                    chartDistributionAvailability.subtitle.style.fontSize="11px"
                    chartDistributionAvailability.subtitle.style.color="#909090"   
                }
                chartDistributionAvailability = JSON.stringify(chartDistributionAvailability)
                dataChart.push(chartDistributionAvailability)
            })
        }


        ObjectiveData.Pasos.map(l=>{
            // Distribucion Porcentual -Disponibilidad consolidada *****
            let chartDistributionConsolidated = sessionStorage.getItem('chartDistributionConsolidated'+l.id_paso)
            chartDistributionConsolidated = JSON.parse(chartDistributionConsolidated)
            chartDistributionConsolidated.title.text= "11. DISTRIBUCIÓN PORCENTUAL - DISPONIBILIDAD CONSOLIDADA / PASO ("+l.nombre_paso +")"
            chartDistributionConsolidated.title.align = 'left'
            chartDistributionConsolidated.title.style.color = '#000'
            chartDistributionConsolidated.title.style.fontFamily= 'Calibri, sans-serif'
            chartDistributionConsolidated.title.style.fontSize="14px"
            chartDistributionConsolidated.title.style.fontWeight= "bold"
            chartDistributionConsolidated = JSON.stringify(chartDistributionConsolidated)
            dataChart.push(chartDistributionConsolidated)

        })
        ObjectiveData.Pasos.map(l=>{
            // Distribucion Porcentual- Disponibilidad. entre ISP  *****
            let chartDistributionIsp = sessionStorage.getItem('chartDistributionIsp'+l.id_paso)
            chartDistributionIsp = JSON.parse(chartDistributionIsp)
            chartDistributionIsp.colors= ["#141D39", "#CF6E29", "#30206C","#325088", "#20385F"]
            chartDistributionIsp.title.text= "12. DISTRIBUCIÓN PORCENTUAL - DISPONIBILIDAD ENTRE ISPS / PASO ("+l.nombre_paso +")"
            chartDistributionIsp.title.align = 'left'
            chartDistributionIsp.title.style.color = '#000'
            chartDistributionIsp.title.style.fontFamily= 'Calibri, sans-serif'
            chartDistributionIsp.title.style.fontSize="14px"
            chartDistributionIsp.title.style.fontWeight= "bold"
            chartDistributionIsp = JSON.stringify(chartDistributionIsp)
            dataChart.push(chartDistributionIsp)

        })
        

        // Tiempo de Respuesta Consolidado
        let chartResponseTimeGeneral = sessionStorage.getItem('chartResponseTimeGeneral')
        chartResponseTimeGeneral = JSON.parse(chartResponseTimeGeneral)
        chartResponseTimeGeneral.title.text="13. TIEMPO DE RESPUESTA CONSOLIDADO"
        chartResponseTimeGeneral.title.align = 'left'
        chartResponseTimeGeneral.title.style.fontSize="14px"
        chartResponseTimeGeneral.legend = {enabled: true}
        chartResponseTimeGeneral.subtitle.text="Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el periodo. El gráfico muestra, para cada paso del objetivo, una línea que representa dichos tiempos encontraste con los SLA OK y SLA Error configurados."
        chartResponseTimeGeneral.subtitle.align="left"
        chartResponseTimeGeneral.subtitle.style.fontSize="11px"
        chartResponseTimeGeneral.subtitle.style.color="#909090"
        chartResponseTimeGeneral = JSON.stringify(chartResponseTimeGeneral)
        dataChart.push(chartResponseTimeGeneral)

        // Tiempo de Respuesta Detalle por Paso    
        ObjectiveData.Pasos.map(l=>{
            let chartResponseTimeForStep = sessionStorage.getItem('chartResponseTimeForStep'+l.id_paso)
            chartResponseTimeForStep = JSON.parse(chartResponseTimeForStep)
            chartResponseTimeForStep.title.text= "14. TIEMPO DE RESPUESTA DETALLE POR PASO ("+l.nombre_paso +")"
            chartResponseTimeForStep.title.align = 'left'
            chartResponseTimeForStep.title.style.fontSize="14px"
            chartResponseTimeForStep.legend = {enabled: true}
            if (l.id_paso === "0") {
                chartResponseTimeForStep.subtitle.text="Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el periodo. El gráfico muestra, para cada paso del objetivo, una línea que representa dichos tiempos encontraste con los SLA OK y SLA Error configurados."
                chartResponseTimeForStep.subtitle.align="left"
                chartResponseTimeForStep.subtitle.style.fontSize="11px"
                chartResponseTimeForStep.subtitle.style.color="#909090"
            }
            chartResponseTimeForStep = JSON.stringify(chartResponseTimeForStep)
            dataChart.push(chartResponseTimeForStep)
        })

        // TIEMPO DE RESPUESTA: POR DÍA DE LA SEMANA
        let chartResponseTimeGeneralDay = sessionStorage.getItem('chartResponseTimeGeneralDay') 
        chartResponseTimeGeneralDay = JSON.parse(chartResponseTimeGeneralDay)
        chartResponseTimeGeneralDay.title.text="15. TIEMPO DE RESPUESTA: POR DÍA DE LA SEMANA"
        chartResponseTimeGeneralDay.title.align = 'left'
        chartResponseTimeGeneralDay.title.style.fontSize="14px"
        chartResponseTimeGeneralDay = JSON.stringify(chartResponseTimeGeneralDay)
        dataChart.push(chartResponseTimeGeneralDay)

       ObjectiveData.Pasos.map(l=>{    
            // Tiempo de Respuesta Detalle por Monitor
            let chartResponseTimeForNode = sessionStorage.getItem('chartResponseTimeForNode'+l.id_paso)
            chartResponseTimeForNode = JSON.parse(chartResponseTimeForNode)
            chartResponseTimeForNode.title.text= "16. TIEMPO DE RESPUESTA DETALLE POR MONITOR ("+l.nombre_paso +")"
            chartResponseTimeForNode.title.align = 'left'
            chartResponseTimeForNode.title.style.fontSize="14px"
            chartResponseTimeForNode.legend = {enabled: true}
            chartResponseTimeForNode = JSON.stringify(chartResponseTimeForNode)
            dataChart.push(chartResponseTimeForNode)
            
        })

        let nameObjetivo = 'Reporte_Periodico_'+ObjectiveData.nombre+'_Mes_'+selectMonth+'_Año_'+actualYear

        var data ={"charts":dataChart, // Graficos
                    "token":token,
                    "name":nameObjetivo} // Token  
                
        var data =JSON.stringify(data)
        this.processData(data,ObjectiveData, selectMonth,actualYear)
    } 

    processData = async(data,ObjectiveData, selectMonth,actualYear) => {
                
        const status = await getPdfPeriodical(data)
        if (status) {
            this.fetchConsolidado(ObjectiveData, selectMonth,actualYear)
        }
    }

    processDataConsolidado = async(data,nameObjetivo) => {
        const status = await getPdfPeriodical(data)
        if (status) {
            // window.open("http://0.0.0.0:5000/checkPdf/"+nameObjetivo)
            window.open("https://api-ar.atentus.com/checkPdf/"+nameObjetivo)

            this.setState({
                modalLoad:false,
                modalnoData:false,
                modalPdf:true
            })
        }
        
    }

    sendData=()=>{
        const {ObjectiveData, selectMonth,actualYear}=this.state
        this.setState({
            modalLoad:true,
            modalnoData:false,
            modalPdf:false
        })
        setTimeout(
            () => this.prepareData(ObjectiveData, selectMonth,actualYear),
            500
        )
    } 

    render() {
        const {params, schedule,actualYear, selectMonth, indexMonth, ObjectiveData, modalLoad, modalPdf,modalnoData}=this.state
        const {classes}=this.props
        return (
            <Grid
                container
                spacing={1}
            >
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={modalLoad}
                    //onClose={this.setCloseModal}
                    style={{
                        //maxHeight:'40vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 100,
                    }}               
                >
                    <Fade in={modalLoad}>
                        <BarLoader sizeUnit={"px"}  width={350} height={7} color="#00acc1" loading={true}/>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={modalPdf}
                    //onClose={this.setCloseModal}
                    style={{
                        //maxHeight:'40vh',
                        
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 100,
                    }}               
                >
                    <Fade in={modalPdf}>
                        {/* <Grid container spacing={2} style = {{backgroundColor : "#37312f" ,width: "30%"}}> */}
                        <Grid container spacing={2} style = {{backgroundColor : "white" ,width: "25%"}}>
                        {/* <Grid container spacing={4} style = {{backgroundColor : "transparent" }}> */}
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}      
                            >
                                <Button     
                                    // style ={{border:"orange 2px solid"}}
                                    className={classes.buttonPeriodical} 
                                    size="large"
                                    startIcon={<ArrowBackIosIcon />} 
                                    onClick={this.handlePeriodical.bind()}> 
                                    Volver a Filtro de Reportes Periódicos 
                                </Button>
                                
                            </Grid>

                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}      
                            >
                                <Button 
                                    // style ={{border:"orange 2px solid"}} 
                                    className={classes.buttonPeriodical}
                                    startIcon={<CloudDownloadIcon />}
                                    onClick={this.sendData}
                                    size="large"
                                    >
                                    <Typography variant="button">Descargar Pdf</Typography>
                                </Button>

                            </Grid>
                        </Grid>
                    </Fade>      
                                
                </Modal>    

                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={modalnoData}
                    //onClose={this.setCloseModal}
                    style={{
                        //maxHeight:'40vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 100,
                    }}               
                >
                    <Fade in={modalnoData}>
                        <Grid container spacing={4} style = {{backgroundColor : "transparent"}}>
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}      
                            >
                                <Button 
                                    // style ={{border:"orange 2px solid"}} 
                                    className={classes.buttonPeriodical}
                                    startIcon={<ArrowBackIosIcon />} 
                                    onClick={this.handlePeriodical.bind()}
                                    size="large"> 
                                    Volver a Filtro Reportes Periódicos 
                                </Button>
                            </Grid>
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}      
                            >
                                <br /><span className={classes.label}>¡¡ NO EXISTE DATA PARA ESTE MES !!</span>
                            </Grid>
                        </Grid>
                    </Fade>      
                                
                </Modal>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                    
                >
                <Availability 
                // DISPONIBILIDAD CONSOLIDADA
                    params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={7}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                   
                >
                <Availability 
                // DISPONIBILIDAD CONSOLIDADA POR PASO
                    params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={8}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >   
                {/* Tiempo de Respuesta Consolidado */}
                    <ResponseTime params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Tiempo de Respuesta" period="c"
                    typePeriod={3} typeGraph={0}/>
                </Grid>

                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Tiempo de Respuesta Detalle por Paso */}
                   <ResponseTime params={this.props} schedule={schedule} periodical={true} year={actualYear}
                        month={selectMonth} indexMonth={indexMonth} title="Tiempo de Respuesta" period="c" pdf={true}
                        typePeriod={3} typeGraph={1} step={ele}/>
                    </Grid>
                ))}
                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Tiempo de Respuesta Detalle por Monitor  */}
                   <ResponseTime params={this.props} schedule={schedule} periodical={true} year={actualYear}
                        month={selectMonth} indexMonth={indexMonth} title="Tiempo de Respuesta" period="c" pdf={true}
                        typePeriod={3} typeGraph={2} step={ele}/>
                    </Grid>
                ))}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                               
                >
                    {/* Disponibilidad Distribución Porcentual */}
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={4}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Disponibilidad Total Consolidada */}
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={0}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Disponibilidad Uptime Real */}
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={1}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Disponibilidad Consolidada Por ISP */}
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={2}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Disponibilidad Detalle Por ISP */}
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={5}/>
                </Grid>    
                <Grid
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    xl={7}
                    ref={this.summaryTable}                              
                >
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={9}/>
                </Grid> 
                
                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}                                  
                    >
                    {/* Distribucion Porcentual /  - Dispo. consolidada - Dispo. entre ISP - Disponibilidad  */}
                    <Percentage  periodical={true} schedule={schedule} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="" period="c"
                    typeGraph={0} steps={ObjectiveData.Pasos} indexStep={ele.id_paso} isStep={true}/>
                    </Grid>
                ))}
                 {/*Disponibilidad Downtime Global Por Paso */}
                {/*                  
                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}                                  
                    >
                       
                    <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                        month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                        typePeriod={3} typeGraph={6} steps={ObjectiveData.Pasos} indexStep={ele.id_paso} isStep={true}/>
                    </Grid>   
                ))}
                 */}

                 {/* TABLA  DOWNTIME GLOBAL*/}
                <Grid
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    xl={7}                               
                >
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={10}/>
                </Grid>
                
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                              
                >
                    {/* ACA HAY DOS HICE UNO --- TIEMPO DE RESPUESTA: POR DÍA DE LA SEMANA */}
                    {/* FALTA TABLA CON PAGINADOR */}
                    <Percentage  periodical={true} schedule={schedule} year={actualYear}
                     month={selectMonth} indexMonth={indexMonth} title="" period="c"
                     typeGraph={1} steps={ObjectiveData.Pasos} pdf={true}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                
                >
                    {/* Disponibilidad Frecuencia Absoluta */}
                    <Statistics params={this.props} schedule={schedule} periodical={true}
                    year={actualYear} month={selectMonth} indexMonth={indexMonth} title="Disponibilidad"
                        period="c" id="availability-h" typePeriod={3} typeGraph={0} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                      
                >
                    {/* Disponibilidad Frecuencia Acumulada */}
                    <Statistics params={this.props} schedule={schedule} periodical={true}
                    year={actualYear} month={selectMonth} indexMonth={indexMonth}
                        title="Disponibilidad" period="c" id="availability-h" typePeriod={3} typeGraph={1}/>
                </Grid>
            </Grid>
            
        );
    }
}

export default compose(withWidth(), withStyles(styles))(PdfPeriodical);

